var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWhite15X15 = function SvgCloseWhite15X15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.998
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.261 7.498 5.37-5.357A1.254 1.254 0 1 0 12.858.368l-5.357 5.37L2.143.367A1.254 1.254 0 0 0 .37 2.14l5.37 5.357-5.37 5.357a1.254 1.254 0 1 0 1.773 1.773L7.5 9.257l5.357 5.37a1.254 1.254 0 1 0 1.773-1.773Z",
    fill: "#eff0f6"
  })));
};
export default SvgCloseWhite15X15;